import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AppInsightsService {
    private appInsights: ApplicationInsights;

    constructor() {
        this.appInsights = new ApplicationInsights({
            config: {
                connectionString: environment.appInsightsConnectionString,
            },
        });
        this.appInsights.loadAppInsights();
        this.appInsights.addTelemetryInitializer((envelope) => {
            if (envelope && envelope.baseType === 'RemoteDependencyData') {
                if (envelope.baseData) {
                    const data = envelope['baseData'];
                    if (data) {
                        const target = data['target'];
                        if (
                            (target?.includes('google-analytics.com') ||
                                target?.includes('analytics.google.com')) &&
                            data['type'] === 'Fetch'
                        ) {
                            data['success'] = true;
                        }
                    }
                }
            }
        });
    }

    logException(exception: Error, errorMessage: string) {
        this.appInsights.trackException({
            exception,
            properties: { errorMessage },
        });
    }
}
